<template>
	<div class="section-content">
		<div class="page-title">
			<div style="padding-top:2%;">
				道佑简介
				<img src="../assets/images/home_TitleLine.png" />
			</div>
		</div>
		<div style="position: relative;overflow: hidden;" class="mainHeight">
			<video :src="detailInfo.backFile" autoplay loop muted style="width: 100vw;obiect-fit:cover;overflow: hidden;"></video>
			<!-- <el-image fit="cover" :src="detailInfo.backVideoImg" style="height: 100%;width: 100%;" alt="" /> -->
			<!-- <video-player class="video-player vjs-custom-skin" ref="videoUrl"
				style="height: 100%;width: 100%;overflow: hidden;" :playsinline="true" :options="{
						  playbackRates: [0.7, 1.0, 1.5, 2.0], //播放速度
						  autoplay: true, //如果true,浏览器准备好时开始回放。
						  controls: false, //控制条
						  preload: true, //视频预加载
						  muted: true, //默认情况下将会消除任何音频。
						  loop: true, //导致视频一结束就重新开始。
						  language: 'zh-CN',
						  aspectRatio: '16:9', // 将播放器置于流畅模式，并在计算播放器的动态大小时使用该值。值应该代表一个比例 - 用冒号分隔的两个数字（
						  fluid: true,
						  sources: [
						    {
						      type: 'video/mp4',
						      src: detailInfo.backFile
						    }
						  ],
						  poster:detailInfo.backVideoImg,
						  notSupportedMessage: '此视频暂无法播放，请稍后再试'
						}"></video-player> -->
			<div class="section-content" style="position: absolute;inset: 0;display: flex
;
    align-items: center;
    justify-content: center;background-color: #ffffff88;">

				<div class="content-section" style="margin-top: -60px;">
					<div style="display:flex;align-items:center;justify-content:space-between">
						<div style="width:41%;display:flex;align-items:center;justify-content:space-between">
							<!-- 左侧数据展示 -->
							<div class="stats-container" style="width:41%;">
								<div class="stat-row">
									<div class="stat-card" :class="{ 'hover-blue': hoveredIndex === 0 }"
										@mouseenter="hoveredIndex = 0" @mouseleave="hoveredIndex = null">
										<div class="stat-label">覆盖城市</div>
										<div class="stat-value">
											<!-- <span class="number">6</span> -->
											<count-to  ref="countRef1"   separator="" class="number" :startVal="0"
												:endVal="detailInfo.coverCity" :duration="9000"></count-to>
											<span class="unit" style="white-space:nowrap">座</span>
										</div>
									</div>
								</div>
								<div class="stat-row">
									<div class="stat-card" :class="{ 'hover-blue': hoveredIndex === 1 }"
										@mouseenter="hoveredIndex = 1" @mouseleave="hoveredIndex = null">
										<div class="stat-label">工作人员</div>
										<div class="stat-value">
											<span>近</span>
											<!-- <span class="number" data-value="100">100</span> -->
											<count-to  ref="countRef2" separator="" class="number" :startVal="0"
												:endVal="detailInfo.staffTotal" :duration="9000"></count-to>
											<span class="unit" style="white-space:nowrap">人</span>
										</div>
									</div>
								</div>
								<div class="stat-row">
									<div class="stat-card" :class="{ 'hover-blue': hoveredIndex === 2 }"
										@mouseenter="hoveredIndex = 2" @mouseleave="hoveredIndex = null">
										<div class="stat-label">帮助当事人</div>
										<div class="stat-value">
											<!-- <span class="number" data-value="10000">10000</span> -->
											<count-to  ref="countRef3" separator="" class="number" :startVal="0"
												:endVal="detailInfo.helpOwnerTotal" :duration="9000"></count-to>
											<span class="unit" style="white-space:nowrap">余位</span>
										</div>
									</div>
								</div>
							</div>
							<div class="stats-container" style="width:46%;">
								<div class="stat-row">
									<div class="stat-card" :class="{ 'hover-blue': hoveredIndex === 3 }"
										@mouseenter="hoveredIndex = 3" @mouseleave="hoveredIndex = null"
										style="padding:8vh 0;">
										<div class="stat-label">累计办理</div>
										<div class="stat-value">
											<!-- <span class="number" data-value="10">5000</span> -->
											<count-to  ref="countRef4" separator="" class="number" :startVal="0"
												:endVal="detailInfo.tiredAuthTotal" :duration="9000"></count-to>
											<span class="unit" style="white-space:nowrap">余案件</span>
										</div>
									</div>
								</div>
								<div class="stat-row">
									<div class="stat-card" :class="{ 'hover-blue': hoveredIndex === 4 }"
										@mouseenter="hoveredIndex = 4" @mouseleave="hoveredIndex = null"
										style="padding:8vh 0;">
										<div class="stat-label">帮助理赔</div>
										<div class="stat-value">
											<!-- <span class="number" data-value="10">0</span> -->
											<count-to  ref="countRef5" separator="" class="number" :startVal="0"
												:endVal="detailInfo.helpRedress" :duration="9000"></count-to>
											<span class="unit" style="white-space:nowrap">亿元+</span>
										</div>
									</div>
								</div>
							</div>
						</div>

						<!-- 右侧介绍 -->
						<div class="intro-container">
							<h1 class="company-name">{{detailInfo.title}}</h1>
							<p class="intro-text">
							<div v-html="detailInfo.summaryContent" class="htmlView"> </div>
							</p>
							<img @click="playVideo" :src="require('../assets/images/dyjjbf.png')" />
						</div>
					</div>
				</div>
			</div>
		</div>

		<el-dialog :visible.sync="isShowPlay" width="60%">
			<video-player class="video-player vjs-custom-skin" ref="videoUrl" style="width: 100%;border-radius: 4px;"
				:playsinline="true" :options="{
		  			  playbackRates: [0.7, 1.0, 1.5, 2.0], //播放速度
		  			  autoplay: true, //如果true,浏览器准备好时开始回放。
		  			  controls: true, //控制条
		  			  preload: true, //视频预加载
		  			  muted: false, //默认情况下将会消除任何音频。
		  			  loop: false, //导致视频一结束就重新开始。
		  			  language: 'zh-CN',
		  			  aspectRatio: '16:9', // 将播放器置于流畅模式，并在计算播放器的动态大小时使用该值。值应该代表一个比例 - 用冒号分隔的两个数字（
		  			  fluid: true,
		  			  sources: [
		  			    {
		  			      type: 'video/mp4',
		  			      src: detailInfo.backFile
		  			    }
		  			  ],
		  			  poster:detailInfo.backVideoImg,
		  			  notSupportedMessage: '此视频暂无法播放，请稍后再试'
		  			}"></video-player>
		</el-dialog>
	</div>

</template>

<script>
	import {
		summaryList
	} from '@/api/webstation.js'
	import CountTo from 'vue-count-to';
	export default {
		name: 'homeOne',
		components: {
			CountTo
		},
		mounted() {
			this.windowHeight = window.innerHeight
		},
		data() {
			return {
				isShowPlay: false,
				detailInfo: {},
				hoveredIndex: null,
				windowHeight: ''
			}
		},
		computed: {
			backgroundStyle() {
				return {
					background: `url(${this.detailInfo.backVideoImg}) no-repeat`,
					// height: '87%',
					'background-size': '100% 100%',
					'display': 'flex'
					// align-items: center;
				};
			}
		},
		created() {
			this.getsummaryList()

		},
		methods: {
			startCount(){
				this.$refs['countRef1'].start()
				this.$refs['countRef2'].start()
				this.$refs['countRef3'].start()
				this.$refs['countRef4'].start()
				this.$refs['countRef5'].start()
			},
			
			playVideo(data) {
				this.$router.push({
					path: 'about?id=2'
				});
			},
			getsummaryList() {
				let that = this
				summaryList({
					"pageNum": "1", //当前页
					"pageSize": "1", //每页展示的条数
					"showModel": '1'
				}).then(res => {
					if (res.code == 200) {
						that.detailInfo = res.rows[0]
						that.detailInfo.coverCity = parseInt(that.detailInfo.coverCity)
						that.detailInfo.staffTotal = parseInt(that.detailInfo.staffTotal)
						that.detailInfo.helpOwnerTotal = parseInt(that.detailInfo.helpOwnerTotal)
						that.detailInfo.tiredAuthTotal = parseInt(that.detailInfo.tiredAuthTotal)
						that.detailInfo.helpRedress = parseInt(that.detailInfo.helpRedress)
					}
				})
			}
		},
	}
</script>

<style scoped>
	@import '../assets/home.css';

	.mainHeight {
		height: calc(100vh - 13vh);
	}
	.htmlView /deep/ p  {
		 
		margin: auto;
		 
		line-height: 160%;
		font-size: 1.6vw;
		 color: #000; 
		text-align: left;
		display: flex;
		text-indent: 2em;
		 
		
	}
</style>


// WEBPACK FOOTER //
// src/components/home_four.vue